import React, { useState, useEffect, useRef } from 'react';
import './IndustryLeaders.css';

const IndustryLeaders = () => {
  const scrollContainerRef = useRef(null);
  const autoScrollIntervalRef = useRef(null);

  const testimonials = [
    {
      id: 1,
      name: "Carolin Kindermann",
      company: "",
      website: "www.carolinkindermann.de",
      tag: "Business Mentor",
      quote: "GC is the real deal everyone's game to",
      image: "/img/caro.jpg",
      logo: "/img/caro_logo.png",
      logoInverted: true
    },
    {
      id: 2,
      name: "Christian Pichler",
      company: "DevHub",
      website: "www.devhub.at",
      tag: "Web Applications & AI",
      quote: "GC is the real deal everyone's game to",
      image: "/img/chrisi.jpg",
      logo: "/img/devhub.svg",
      logoInverted: true
    },
    {
      id: 3,
      name: "Sebastian Lämmle",
      company: "",
      website: "sebastian-laemmle.com",
      tag: "ENERGY PRACTITIONER",
      quote: "Grant Cardone shares about money that big",
      image: "/img/sebastian.jpg",
      logo: "/img/sebastian_logo.webp",
      logoInverted: true
    },
    {
      id: 4,
      name: "Weinhaus Schowalter",
      company: "",
      website: "weinhaus-schowalter.de",
      tag: "WINE PRODUCER",
      quote: "This guy has got a tight game going & the best conference on the planet",
      image: "/img/martin.jpg",
      logo: "/img/martin_logo.png",
      logoInverted: true
    },
    {
      id: 5,
      name: "ANDREI NINTSCHEW",
      company: "Nintschew & Partner",
      website: "nintschew-partner.at",
      tag: "TAX CONSULTING",
      quote: "GC is showing us all how to take the game to another level.",
      image: "/img/andrei.jpg",
      logo: "/img/andrei_logo.png",
      logoInverted: true
    },
    {
      id: 6,
      name: "Sarah Rickmers",
      company: "Visuelle Magie Design",
      website: "www.visuellemagie-design.de",
      tag: "ENERGETIC BRANDING",
      quote: "Everybody wants to be in his shoes...he has done the work.",
      image: "/img/sarah.jpg",
      logo: "/img/sarah_logo.png",
      logoInverted: true
    },
    // {
    //   id: 8,
    //   name: "PROF.IN. MICHAELA BRAUN",
    //   company: "",
    //   website: "www.michaela-braun.de",
    //   tag: "RECHTSANWÄLTIN & MENTORIN",
    //   quote: "Nothing I won't do for to support his platform.",
    //   image: "/img/michaela_1.jpg",
    //   logo: "/img/michaela_logo.png",
    //   logoInverted: true
    // },
  ];

  // Create infinite loop by tripling the array
  const infiniteTestimonials = [...testimonials, ...testimonials, ...testimonials];
  
  // Start at position 2 (index 2) in the middle set for symmetry
  const initialIndex = testimonials.length + 2;
  const [activeIndex, setActiveIndex] = useState(initialIndex);
  const [isTransitioning, setIsTransitioning] = useState(true);

  // Handle infinite loop reset
  useEffect(() => {
    if (!isTransitioning) return;

    // If we reach the end of the middle set, jump to the same position in the first set
    if (activeIndex >= testimonials.length * 2) {
      const timeout = setTimeout(() => {
        setIsTransitioning(false);
        setActiveIndex(activeIndex - testimonials.length);
        setTimeout(() => setIsTransitioning(true), 20);
      }, 650); // Wait for transition to complete
      return () => clearTimeout(timeout);
    }
    
    // If we reach the beginning of the middle set, jump to the same position in the last set
    if (activeIndex < testimonials.length) {
      const timeout = setTimeout(() => {
        setIsTransitioning(false);
        setActiveIndex(activeIndex + testimonials.length);
        setTimeout(() => setIsTransitioning(true), 20);
      }, 650);
      return () => clearTimeout(timeout);
    }
  }, [activeIndex, testimonials.length, isTransitioning]);

  // Auto-scroll effect
  useEffect(() => {
    const startAutoScroll = () => {
      autoScrollIntervalRef.current = setInterval(() => {
        setActiveIndex((prev) => prev + 1);
      }, 7000); // Alle 3.5 Sekunden weiter
    };

    startAutoScroll();

    return () => {
      if (autoScrollIntervalRef.current) {
        clearInterval(autoScrollIntervalRef.current);
      }
    };
  }, []);

  const resetAutoScroll = () => {
    if (autoScrollIntervalRef.current) {
      clearInterval(autoScrollIntervalRef.current);
    }
    autoScrollIntervalRef.current = setInterval(() => {
      setActiveIndex((prev) => prev + 1);
    }, 7000);
  };

  const scrollToIndex = (index) => {
    setActiveIndex(index);
    resetAutoScroll();
  };

  const handlePrevious = () => {
    setActiveIndex((prev) => prev - 1);
    resetAutoScroll();
  };

  const handleNext = () => {
    setActiveIndex((prev) => prev + 1);
    resetAutoScroll();
  };

  return (
    <div className="industry-leaders-wrapper">
      <div className="il-header-section">
        <h2 className="il-main-title">
       <span className="il-main-title-accent">Clients</span>  & Partners  
        </h2>
        <div className="il-main-title-divider"></div>
        <p className="il-subtitle">
        We work with doers who take responsibility
        and aren't afraid to think bigger than the rest.    
        
      </p>
      </div>

      <div className="il-carousel-container">
        {/* Dekorative Kreise */}
        <div className="il-deco-circle il-deco-circle-1"></div>

        <button className="il-nav-button il-nav-left" onClick={handlePrevious}>
          <img src="/img/down.svg" alt="Previous" style={{ transform: 'rotate(90deg)', width: '30px', height: '30px', filter: 'brightness(0) invert(1)' }} />
        </button>

        <div className="il-carousel-track" ref={scrollContainerRef}>
          {infiniteTestimonials.map((testimonial, index) => {
            const offset = index - activeIndex;
            const isCenter = offset === 0;
            
            // Dynamischer Abstand basierend auf der Position
            let translateX;
            if (offset === 0) {
              translateX = 0;
            } else if (Math.abs(offset) === 1) {
              translateX = offset * 260;
            } else {
              // Äußere Cards: noch näher zur Mitte (40px weniger Abstand)
              translateX = offset > 0 
                ? 270 + (offset - 1) * 180
                : -270 + (offset + 1) * 180;
            }
            
            return (
              <div
                key={`${testimonial.id}-${index}`}
                className={`il-carousel-item ${isCenter ? 'il-active' : ''}`}
                style={{
                  transform: `translateX(${translateX}px) scale(${
                    isCenter ? 1.1 : Math.abs(offset) === 1 ? 0.65 : 0.4
                  })`,
                  opacity: Math.abs(offset) > 2 ? 0 : isCenter ? 1 : Math.abs(offset) === 1 ? 0.5 : 0.25,
                  zIndex: isCenter ? 10 : 5 - Math.abs(offset),
                  transition: isTransitioning ? 'all 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94)' : 'none',
                }}
                onClick={() => scrollToIndex(index)}
              >
                {testimonial.tag && (
                  <div className="il-tag">{testimonial.tag}</div>
                )}
                <div className="il-image-wrapper">
                  <img 
                    src={testimonial.image} 
                    alt={testimonial.name}
                    className="il-testimonial-image"
                  />
                  <div className="il-dark-overlay"></div>
                  {testimonial.logo && (
                    <div className="il-logo-overlay">
                      <img 
                        src={testimonial.logo} 
                        alt={`${testimonial.name} logo`}
                        className={`il-logo-image ${testimonial.logoInverted ? 'il-logo-inverted' : ''}`}
                      />
                    </div>
                  )}
                  <div className="il-gradient-overlay"></div>
                </div>
                <div className="il-testimonial-content">
                  <p className="il-testimonial-name">{testimonial.name}</p>
                  <p className="il-testimonial-company">{testimonial.company}</p>
                  {testimonial.website && (
                    <p className="il-testimonial-website">{testimonial.website}</p>
                  )}
                </div>
              </div>
            );
          })}
        </div>

        <button className="il-nav-button il-nav-right" onClick={handleNext}>
          <img src="/img/down.svg" alt="Next" style={{ transform: 'rotate(-90deg)', width: '30px', height: '30px', filter: 'brightness(0) invert(1)' }} />
        </button>
      </div>

      <div className="il-dots-container">
        {testimonials.map((_, index) => {
          const middleSetIndex = index + testimonials.length;
          const isActive = (activeIndex % testimonials.length) === index;
          return (
            <button
              key={index}
              className={`il-dot ${isActive ? 'il-dot-active' : ''}`}
              onClick={() => scrollToIndex(middleSetIndex)}
            />
          );
        })}
      </div>
    </div>
  );
};

export default IndustryLeaders;

